<template>
  <div>
    <div class="investor-funnel container-fluid pane">
      <InvestorFunnelColumn
        v-for="(column, index) in funnelClassification"
        :key="index"
        :title="column.label"
        :state="column.value"
        :editable="editable"
        @investor-selected="onInvestorSelected"
      />
    </div>
    <InvestorDropOffsList class="container-fluid pane" :investors="dropoffs" />
    <InvestorListModal ref="investorListModal" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import classification from '@/services/startup-classification'
import InvestorFunnelColumn from './InvestorFunnelColumn.vue'
import InvestorDropOffsList from './InvestorDropOffsList.vue'
import InvestorListModal from '@/modules/investor-list/InvestorListModal'

const funnelClassification = classification.filter(
  (item) => item.value !== 'not_interested',
)

export default {
  components: {
    InvestorDropOffsList,
    InvestorFunnelColumn,
    InvestorListModal,
  },
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    wasSidebarCollapsed: false,
    funnelClassification,
  }),
  computed: {
    ...mapState({
      fetchInProgress: (state) => state.investorList.fetchInProgress,
      sidebarCollapsed: (state) => state.common.sidebarCollapsed,
      dropoffs: (state) =>
        state.investorList.investors.filter(
          (investor) => investor.state === 'not_interested',
        ),
    }),
  },
  async created() {
    console.log(' => InvestorFunnel.created | editable:', this.editable)
    const user = await this.$store.dispatch('user/getUser')
    if (user.isStartup) {
      const startupId = user.startup.id
      this.fetch(startupId)
    }

    this.wasSidebarCollapsed = this.sidebarCollapsed
    if (!this.sidebarCollapsed) {
      this.$store.commit('common/COLLAPSE_SIDEBAR')
    }
  },
  destroyed() {
    if (!this.wasSidebarCollapsed) this.$store.commit('common/EXTEND_SIDEBAR')
  },
  methods: {
    fetch(startupId) {
      this.$store.dispatch('investorList/fetchAll', {
        startupId,
        is_personal: 'no',
      })
    },
    onInvestorSelected(investor) {
      console.log(' => onInvestorSelected', investor)
      this.$refs.investorListModal.open(investor)
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';

.investor-funnel {
  display: flex;
  flex-wrap: nowrap;
  padding: 10px;
  background: #fff;
  min-height: 800px;

  div.funnel-column {
    &:last-of-type {
      .ion-chevron-right {
        display: none;
      }
    }
  }
}
</style>
